import { z } from 'zod';

export const translationSegmentSchema = z.union([
    z.object({ _type: z.literal('span'), value: z.string() }),
    z.object({
        _type: z.literal('variable'),
        variableName: z.string(),
    }),
]);

export const translationResponseSchema = z.array(
    z.object({
        key: z.string(),
        translation: z.array(
            z.object({
                _key: z.string(),
                translations: z.array(translationSegmentSchema),
            }),
        ),
    }),
);

export type TranslationSegment = z.infer<typeof translationSegmentSchema>;
export type TranslationDocument = z.infer<
    typeof translationResponseSchema
>[number];

export type TranslationEntry = TranslationDocument['translation'][number];

/** Runtime segment format used by the generated fallback files. */
export type Translation =
    | { readonly type: 'string'; readonly value: string }
    | {
          readonly type: 'interpolated';
          readonly variableName: string;
      };

export type TranslationRecord = Record<string, readonly Translation[]>;
